import React from 'react'
import { UserContext } from '../contexts/UserProvider'

export const useUser = () => React.useContext(UserContext)
